
export default function PreAnalisiInfo() {
  const benefits = [
    {
      icon: 'ri-search-line',
      title: 'Analisi Completa',
      description: 'Valutiamo ogni aspetto del tuo brand: posizionamento, percezione, potenziale di mercato'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Valore Reale',
      description: 'Scopri il vero valore economico del tuo brand con metodologie certificate'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Opportunità',
      description: 'Identifichiamo le aree di miglioramento e le strategie per massimizzare il ROI'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Zero Impegni',
      description: 'La pre-analisi è completamente gratuita, senza vincoli o obblighi futuri'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Cosa Include la Pre-Analisi Gratuita
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Un primo sguardo professionale al tuo brand per capire le sue potenzialità nascoste.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-sm hover:shadow-lg transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-green-500 rounded-lg mb-4">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}